import { FormattedMessageDiv, IconAlert } from '@odmonorepo/core-components';
import { FormattedDate } from 'react-intl';

export const DelayedFundingMessage = ({ fundingDate }: { fundingDate: string }) => (
  <>
    <FormattedMessageDiv
      className="fw-bold"
      id="delayedFunding.date"
      values={{ fundingDate: <FormattedDate value={fundingDate} timeZone="UTC" year="numeric" month="long" day="numeric" /> }}
    />
    <FormattedMessageDiv id="delayedFunding.notice" />
  </>
);

export const DelayedFundingNotification = ({ fundingDate }: { fundingDate: string }) => (
  <IconAlert className="m-0" variant="info">
    <DelayedFundingMessage fundingDate={fundingDate} />
  </IconAlert>
);

export default DelayedFundingNotification;
